<script setup lang="ts">
/**
 * @description UI-kit typography component — plain text
 * @category UI / Typography
 * @figma https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3360-100151
 */
import type { AppTextProps } from '@UI/Typography/AppText/types/interfaces'

import { useAppText } from '@UI/Typography/AppText/composables/use-app-text.hook'

defineOptions({ name: 'AppText' })

const props = withDefaults(defineProps<AppTextProps>(), {
  name: 'body1',
  align: 'inherit',
  textDecoration: 'none',
  block: false,
  truncate: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  resolvedTag,
  classList,
  handleClick,
} = useAppText({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="resolvedTag"
    :class="classList"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="../styles/_app-text.scss" />
